import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import Loader from "../../components/Loader";
import { useQuery } from "@tanstack/react-query";
import Table from "../../components/Table";
import { IeloColumns } from "../../components/headerContent";
import IeloContrat from "./IeloContrat";
import NumberCard from "../../components/Card/NumberCard";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import IeloService from "./IeloService";

export default function Ielo() {
    const { apiUrl } = useContext(AuthContext);
    const { t } = useTranslation();
    const [filteredData, setFilteredData] = useState([]);
    const [link, setLink] = useState(null);
    const [linkType, setLinkType] = useState(null);

    const getServicesIelo = async () => {
        try {
            const res = await axios.get(`${apiUrl}ielo/services`, {
                withCredentials: true,
            });
            return res.data;
        } catch (error) {
            return { result: { objs: [] } };
        }
    };

    const servicesIelo = useQuery({
        queryKey: ["Ielo"],
        queryFn: getServicesIelo
    });

    const services = servicesIelo.data?.result?.objs ?? [];

    useEffect(() => {
        if (!servicesIelo.isFetching) {
            setFilteredData(services);
        }
    }, [servicesIelo.isFetching, services]);

    return (
        <div className="ecp-container">
            <div className="ecp-container-content ielo">
                {!servicesIelo.isLoading && !servicesIelo.isFetching ? (
                    <>
                        {!link ? (
                            <>
                                <div className="ecp-container-content-header">
                                    <div className="ecp-container-content-header-title">
                                        <div className="page-title page-logo">
                                            <h1 className="page-title">Liaison internet</h1>
                                        </div>
                                    </div>
                                </div>
                                <section className="page-section">
                                    <NumberCard
                                        title={`${t("Nombre d'équipements disponibles")}`}
                                        number={filteredData.length}
                                        logo={faCircleCheck}
                                        color="#AEC353"
                                        stylesIcons="logo-certificats"
                                    />
                                </section>

                                <div className="cato-content-table">
                                    <Table tableData={filteredData} tableColumns={IeloColumns} setLink={setLink} setLinkType={setLinkType} />
                                </div>
                            </>
                        ) : linkType === "contract" ? (
                            <IeloContrat contractRef={link} setLink={setLink} setLinkType={setLinkType} />
                        ) : linkType === "service" ? (
                            <IeloService serviceRef={link} setLink={setLink} setLinkType={setLinkType} />
                        ) : null}
                    </>
                ) : (
                    <Loader />
                )}
            </div>
        </div>
    );
}
